/* unplugin-vue-components disabled */import script from "./Footer.vue?vue&type=script&setup=true&lang=js"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=5f090bcc&lang=scss&scoped=true"

import exportComponent from "D:\\H5Projects\\1carbon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f090bcc"]])

export default __exports__